import { render } from "./huesped.vue?vue&type=template&id=84c81694"
import script from "./huesped.vue?vue&type=script&lang=js"
export * from "./huesped.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__